// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class NotificationStats {
  readonly totalReminders: number;
  readonly totalNotifications: number;
  readonly unreadNotifications: number;

  constructor(data: { [key: string]: any } = {}) {
    this.totalReminders = data.totalReminders === undefined ? 0 : data.totalReminders;
    this.totalNotifications = data.totalNotifications === undefined ? 0 : data.totalNotifications;
    this.unreadNotifications =
      data.unreadNotifications === undefined ? 0 : data.unreadNotifications;
  }

  static zero(): NotificationStats {
    const zeroValues: ExcludeMethodsDeep<NotificationStats> = {
      totalReminders: 0,
      totalNotifications: 0,
      unreadNotifications: 0,
    };
    return new NotificationStats(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type NotificationStatsWireFormat = {
  totalReminders: number;
  totalNotifications: number;
  unreadNotifications: number;
};

type NewNotificationStatsProps = PartialDeep<NotificationStats, { recurseIntoArrays: true }>;
export const NewNotificationStats: (props: NewNotificationStatsProps) => NotificationStats = (
  props,
) => new NotificationStats(props);

type NewNotificationStatsFromWireFormatProps = PartialDeep<
  NotificationStatsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewNotificationStatsFromWireFormat: (
  props: NewNotificationStatsFromWireFormatProps,
) => NotificationStats = (props) => new NotificationStats(props);
